import { CitationCommonStyle } from './citationCommon';

export const CreateCampaignHeaderStyles = {
  container: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: { xs: 'flex-start', sm: 'center' },
    paddingTop: { xs: '16px', sm: '24px' },
    paddingBottom: { xs: '16px', sm: '20px' },
    flexDirection: { xs: 'column', sm: 'row' },
    gap: { xs: '12px', sm: '0px' },
    width: '100%',
    boxSizing: 'border-box'
  },
  titleContainer: {
    ...CitationCommonStyle.layout.flexRowCenter
  },
  title: {
    ...CitationCommonStyle.typography.headingLarge
  },
  tooltipText: {
    ...CitationCommonStyle.typography.tooltipText
  },
  helpIcon: {
    ...CitationCommonStyle.icons.helpIcon
  },
  locationToggleContainer: {
    ...CitationCommonStyle.components.borderedContainer,
    width: { xs: '100%', sm: 'auto' },
    justifyContent: { xs: 'space-between', sm: 'flex-start' }
  },
  locationToggleLabel: {
    ...CitationCommonStyle.typography.bodyMedium
  },
  switch: {
    ...CitationCommonStyle.components.switch
  }
};

